module.exports = __webpack_public_path__ + "img/12_no.4b3b2207.svg";